export default __webpack_public_path__ + "static/media/companyOwnedVehiclesWithGPS.2fee8ba0.svg";